import React from "react";
import { LinkRoute } from "../components/LinkRoute";
import { ROOT } from "./CONSTANTS";

export const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-[80vh]">
      <div className="text-center">
        <h1 className="text-7xl font-bold text-gray-800 mb-4">404</h1>
        <p className="text-xl text-gray-500 mb-6">Sayfa bulunamadı</p>
        <LinkRoute
          to={ROOT}
          className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
        >
          Ana Sayfaya Dön
        </LinkRoute>
      </div>
    </div>
  );
};
